import { makeVar } from '@apollo/client';

export const debtorCollectionPriorityFilter = makeVar(null);

export const companyFilter = makeVar({});
